// @ts-check
import classNames from 'classnames';
import { graphql } from 'gatsby';
import React from 'react';
import { ConstructBasicElement, GetCopyFromJson } from '~/contentstack/rendering';

import './ListSection.scss';

export const query = graphql`
	fragment ListSectionFragment on Ozk_content_blockModular_blocksCopyContent {
		list {
			list_type
			copy {
				json
			}
		}
	}
`;

/**
 * @typedef {'none' | 'bullet' | 'letter' | 'checkmark'} ListType
 * @typedef ListOptions
 * @property {ListType} list_type
 * @property {import('../CSTypes').CSJRTE[]} copy
 * 
 * @typedef ListProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<ListOptions>} [options]
 * 
 * @param {ListProps} props
 */
const ListSection = ({ options }) => {
	const output = GetCopyFromJson(options.copy, ConstructBasicElement('p', 'fragment'));

	return (
		<ul className={classNames('list-section', options.list_type)} {...options.$?.list_type}>
			{output.flat().map((out, i) => (
				<li key={i}>{out}</li>
			))}
		</ul>
	);
};

export default ListSection;
